import { Extension } from "@tiptap/core";
import { CoreExtensionNames } from "../constants/extention";

type TActiveDropbarExtensions = CoreExtensionNames.MENTION;

export interface UtilityExtensionStorage {
  activeDropbarExtensions: TActiveDropbarExtensions[];
  isTouchDevice: boolean;
}

declare module "@tiptap/core" {
  interface Commands {
    utility: unknown;
  }
  interface Storage {
    [CoreExtensionNames.UTILITY]: UtilityExtensionStorage;
  }
}

interface UtilityExtensionProps {
  isTouchDevice: boolean;
  isEditable?: boolean;
}

export const UtilityExtension = (props: UtilityExtensionProps) => {
  const { isTouchDevice } = props;

  return Extension.create<Record<string, unknown>, UtilityExtensionStorage>({
    name: "utility",
    priority: 1000,

    addStorage() {
      return {
        activeDropbarExtensions: [],
        isTouchDevice
      };
    }
  });
};
